import React, { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";

import { createeDetail, getAlleDetail, updatSlideData } from "../services/apis";
import CircularProgressBar from "../utils/CircularProgressBar";
import { showErrorToast } from "../components/toastComponent/ToastComponent";

const NewEdetail = (props) => {
  const [isloading, setIsloading] = useState(false);
  const [edtailList, setEdtailList] = useState(undefined);

  const errNotify = () => showErrorToast('Wow so easy!');

  // const createNewEdetail = (payload) => {
  //   const edetailPayload = {
  //     name: "munirajTestEdeail12",
  //     desc: "PainCure iDetail",
  //     slides: [],
  //     thumbnail: "",
  //     tags: ["PainCure", "DPN"],
  //     created: {
  //       userid: `a95801bd-d666-4eee-87a1-686a0fd1981f`,
  //       username: "Muniraj",
  //       name: "Muniraj G",
  //     },
  //   };
  //   setIsloading(true);
  //   createeDetail(edetailPayload, (response, err, errorCode) => {
  //     if (err) {
  //       alert(errorCode);
  //       //showError(errorCode);
  //       errNotify();
  //       setIsloading(false);
  //     } else {
  //       toast.success("", {
  //         position: "top-right",
  //         autoClose: 5000,
  //         hideProgressBar: true,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: false,
  //         progress: undefined,
  //       });
  //       setIsloading(false);
  //     }
  //   });
  // };

  useEffect(() => {
    getEdetailList();
    return () => {
      // clean up functions goes here
    };
  }, []);

  const getEdetailList = () => {
    setIsloading(true);

    getAlleDetail({
      callBack: (response, err, errorCode) => {
        if (err) {
          errNotify();
          setIsloading(false);
        } else {
          setEdtailList(response.data.decks);
          setIsloading(false);
        }
      },
    });
  };

  const updatPage = (payload) => {
    const updateData = {
      key_message: "Administration 2",
      content: "<h1>Muniraj Text update Slide</h1>",
      slides: [
        {
          index: 2,
          slideid: "62d6c449ad6faa5b18eb26f6",
          children: [],
        },
      ],
    };

    updatSlideData(updateData, (response, err, errorCode) => {
      if (err) {
        errNotify();
        setIsloading(false);
      } else {
        setIsloading(false);
      }
    });
  };

  return (
    <div className="loginPage">
      {isloading && (
        <CircularProgressBar
          isloading={isloading}
          setIsloading={setIsloading}
        />
      )}
      <div>
        <button onClick={updatPage}>Create e-Detail</button>
      </div>
      <div className="row">
        {edtailList &&
          edtailList.map((item, index) => {
            return (
              <div className="col-md-4" key={item._id}>
                {item.name}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default NewEdetail;
